import { useState, useEffect, useRef } from 'react';

export const OutsideClickDetector = (ref, isOpenned) => {
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    const handleOutsideClick = e => {
      if (ref.current && !ref.current.contains(e.target) && isOpenned)
        setIsClicked(true);
      else setIsClicked(false);
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [ref, isOpenned]);

  return isClicked;
};

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    let id = setInterval(() => {
      savedCallback.current();
    }, delay);
    return () => clearInterval(id);
  }, [delay]);
};
